import { render, staticRenderFns } from "./SelectCasePageTable.vue?vue&type=template&id=33aed3df&scoped=true"
import script from "./SelectCasePageTable.vue?vue&type=script&lang=ts"
export * from "./SelectCasePageTable.vue?vue&type=script&lang=ts"
import style0 from "./SelectCasePageTable.vue?vue&type=style&index=0&id=33aed3df&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33aed3df",
  null
  
)

export default component.exports